export default "__VITE_ASSET__CqcLR8MO__"